// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Data
import { rentalTerms } from "pages/CarRentals/sections/data/carRentalData";

function Terms() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <MKTypography variant="h3" textAlign="center" mb={1}>
          Good to know
        </MKTypography>
        <MKTypography
          variant="body1"
          color="text"
          textAlign="center"
          mb={5}
          mx="auto"
          sx={{ maxWidth: 720 }}
        >
          A couple of quick details about transfers and rentals so there are no surprises when you
          arrive.
        </MKTypography>
        <Grid container spacing={4}>
          {rentalTerms.map((term) => (
            <Grid item xs={12} md={6} key={term.title}>
              <MKBox
                p={{ xs: 3, md: 4 }}
                height="100%"
                borderRadius="lg"
                sx={{
                  backgroundColor: "grey.100",
                  border: "1px solid",
                  borderColor: "grey.300",
                }}
              >
                <MKBox display="flex" alignItems="center" mb={2}>
                  <MKBox
                    variant="gradient"
                    bgColor="info"
                    display="inline-flex"
                    alignItems="center"
                    justifyContent="center"
                    mr={2}
                    sx={{ width: 48, height: 48, borderRadius: "lg", flexShrink: 0 }}
                  >
                    <Icon sx={{ color: "#fff", fontSize: "1.5rem !important" }}>{term.icon}</Icon>
                  </MKBox>
                  <MKTypography variant="h5">{term.title}</MKTypography>
                </MKBox>
                <MKTypography variant="body2" color="text">
                  {term.body}
                </MKTypography>
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Terms;
